/* Estrani - categoriechips bovenaan de collectiepagina. Door Claude gebouwd,
   veilig te verwijderen: haal de twee regels ai-collectiechips.* uit
   snippets/ai-hoofd.liquid.

   Waarom dit bestaat: op /collections/jassen stond de titel, de beschrijving
   en dan meteen het raster. Geen enkele link naar de zes onderliggende
   collecties. Wie daar binnenkwam via Google of een advertentie kon alleen
   nog via het menu naar Winterjassen. Nu staat er een rij knopjes:

     op een hoofdcollectie  -> de onderliggende collecties
     op een subcollectie    -> "Alle jassen" + alle zusjes, huidige gemarkeerd
     op /collections/all    -> de drie hoofdcollecties

   De lijst komt uit hetzelfde Shopify-menu als de rest van de navigatie; er
   staat hier niets hard gecodeerd. Pas je het menu aan, dan volgt dit mee.

   RUIMTE VOORAF. Gemeten: tekende dit script de rij pas na het laden, dan
   schoof alles eronder 62px naar beneden en zag je de producten verspringen.
   Daarom zet reserveer() meteen een leeg vak neer zodra het titelblok in de
   pagina verschijnt - nog tijdens het inlezen, dus voor er iets getekend
   wordt. ai-collectiechips.css geeft dat vak dezelfde hoogte als de knopjes.
   bouw() vult datzelfde vak later op, of haalt het weg als er niets te tonen
   valt. Het script staat daarom ook zonder defer in de kop. */
(function () {
  'use strict';

  function tekst(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function handleVan(href) {
    if (!href) return '';
    var m = href.split('?')[0].split('#')[0].match(/\/collections\/([^/]+)/);
    return m ? m[1] : '';
  }

  function opCollectie() {
    return /^\/collections\/[^/]+\/?$/.test(location.pathname);
  }

  /* De menustructuur uitlezen zoals ze in de lade staat: per hoofdcollectie
     een naam, een eigen link en haar onderliggende collecties. */
  function leesMenu() {
    var nav = document.querySelector('.menu-drawer__navigation');
    if (!nav) return [];
    var groepen = [];
    var ouders = nav.querySelectorAll('.menu-drawer__menu--childlist > li');
    for (var i = 0; i < ouders.length; i++) {
      var li = ouders[i];
      var a = li.querySelector('a');
      if (!a) continue;
      var kinderen = [];
      var kl = li.querySelectorAll('ul.menu-drawer__menu--grandchildlist a');
      for (var j = 0; j < kl.length; j++) {
        kinderen.push({ naam: tekst(kl[j]), href: kl[j].getAttribute('href'), handle: handleVan(kl[j].getAttribute('href')) });
      }
      groepen.push({ naam: tekst(a), href: a.getAttribute('href'), handle: handleVan(a.getAttribute('href')), kinderen: kinderen });
    }
    return groepen;
  }

  function kies(groepen, hier) {
    var i, g;
    if (hier === 'all') {
      var top = [];
      for (i = 0; i < groepen.length; i++) {
        top.push({ naam: groepen[i].naam, href: groepen[i].href, actief: false });
      }
      return top.length > 1 ? top : null;
    }
    /* Staan we op een hoofdcollectie? Dan tonen we haar kinderen. */
    for (i = 0; i < groepen.length; i++) {
      if (groepen[i].handle === hier && groepen[i].kinderen.length) {
        return groepen[i].kinderen.map(function (k) {
          return { naam: k.naam, href: k.href, actief: false };
        });
      }
    }
    /* Of op een subcollectie? Dan tonen we haar zusjes, met vooraan een weg
       terug naar de hele categorie. */
    for (i = 0; i < groepen.length; i++) {
      g = groepen[i];
      for (var j = 0; j < g.kinderen.length; j++) {
        if (g.kinderen[j].handle !== hier) continue;
        var rij = [{
          naam: 'Alle ' + g.naam.toLowerCase(),
          href: g.href, actief: false
        }];
        for (var k = 0; k < g.kinderen.length; k++) {
          rij.push({ naam: g.kinderen[k].naam, href: g.kinderen[k].href, actief: g.kinderen[k].handle === hier });
        }
        return rij;
      }
    }
    return null;
  }

  function plek() {
    /* Liefst onder de titel en de beschrijving, want daar hoort het. Dat blok
       heeft al de juiste marges van de pagina. Vindt het script dat blok niet,
       dan komt de rij vlak boven het productraster te staan. */
    var h1 = document.querySelector('#MainContent h1');
    var paneel = h1 && h1.closest ? h1.closest('.layout-panel-flex') : null;
    if (paneel) return { ouder: paneel, voor: null };
    var cc = document.querySelector('collection-component');
    if (cc && cc.parentNode) return { ouder: cc.parentNode, voor: cc };
    return null;
  }

  /* Staat vast dat er op deze collectie niets te tonen valt? Dan mag het lege
     vak niet telkens opnieuw gezet worden door de kijker hieronder. */
  var niets = false;

  /* Het lege vak, zo vroeg mogelijk, zodat er later niets verspringt. */
  function reserveer() {
    if (niets) return;
    if (!opCollectie()) return;
    if (document.querySelector('.ai-chips')) return;
    var waar = plek();
    if (!waar) return;
    var nav = document.createElement('nav');
    nav.className = 'ai-chips ai-chips--wacht';
    nav.setAttribute('aria-label', 'Collecties in deze categorie');
    if (waar.voor) waar.ouder.insertBefore(nav, waar.voor);
    else waar.ouder.appendChild(nav);
  }

  function bouw() {
    if (!opCollectie()) return;
    var nav = document.querySelector('.ai-chips');
    /* Al gevuld? Dan is er niets meer te doen. */
    if (nav && !nav.classList.contains('ai-chips--wacht')) return;

    var hier = handleVan(location.pathname);
    var rij = hier ? kies(leesMenu(), hier) : null;

    if (!rij || !rij.length) {
      /* Niets te tonen op deze collectie: het lege vak mag weg. Pas doen als
         het menu echt ingelezen is, anders halen we het te vroeg weg. */
      if (document.querySelector('.menu-drawer__navigation')) {
        niets = true;
        if (nav) nav.remove();
      }
      return;
    }

    if (!nav) {
      var waar = plek();
      if (!waar) return;
      nav = document.createElement('nav');
      nav.className = 'ai-chips ai-chips--wacht';
      nav.setAttribute('aria-label', 'Collecties in deze categorie');
      if (waar.voor) waar.ouder.insertBefore(nav, waar.voor);
      else waar.ouder.appendChild(nav);
    }

    var actief = null;
    rij.forEach(function (c) {
      var a = document.createElement('a');
      a.className = 'ai-chips__chip' + (c.actief ? ' is-actief' : '');
      a.href = c.href;
      a.textContent = c.naam;
      if (c.actief) { a.setAttribute('aria-current', 'page'); actief = a; }
      nav.appendChild(a);
    });
    nav.classList.remove('ai-chips--wacht');

    /* Sta je op een van de laatste subcollecties, dan zou haar knopje buiten
       beeld vallen. Alleen dan meeschuiven: staat het al in beeld, dan laten
       we de rij vooraan staan zodat "Alle jassen" niet half wegvalt. */
    if (actief && actief.offsetLeft + actief.offsetWidth > nav.clientWidth) {
      nav.scrollLeft = Math.max(0, actief.offsetLeft - 16);
    }
  }

  var wacht = null;
  function plan() {
    reserveer();
    if (wacht) return;
    wacht = setTimeout(function () { wacht = null; bouw(); }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bouw);
  } else {
    bouw();
  }
  new MutationObserver(plan).observe(document.documentElement, { childList: true, subtree: true });
  reserveer();
})();
